import React, { useEffect, useState } from 'react';

// material-ui
import { Box, Button, Card, Grid, Switch } from '@mui/material';

// project imports
import { TCInput, TCSelect } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getParamsFromURL } from 'helper/Params';
import { createAdmin, getAdmin, updateAdmin } from 'services/adminServices';
import { roleOption } from 'constant/constant';
import { validation } from 'helper/Form';

import { IconLock, IconLockOpen } from '@tabler/icons';

import { toastMessage } from 'components/Toast/Toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { getUrlCourtCode } from 'helper/Court';

//start here
export default function AddAdmin() {
    const [confirmPassword, setConfirmPassword] = useState('')
    const [joi, setJOI] = useState({
        name: "",
        username: "",
        role: null,
    })

    const [searchParams] = useSearchParams();
    const listAdmin = useLocation().state;

    const partnerId = searchParams.get("partnerId");
    const partnerCode = searchParams.get("partnerCode");
    const placeId = searchParams.get("merchantId");

    const [form, setForm] = useState({
        username: '',
        name: '',
        password: '',
        phoneNumber: '',
        limitedAccess: '',
        role: null,
        isActive: true,
        merchantId: partnerId || '',
    })

    useEffect(() => {
        let { params } = getParamsFromURL(window);
        console.log('log-params ::', params)
        if (params) getAdminDetail(params)
    }, [])

    useEffect(() => {
        setJOI(prev => ({
            name: !validation.isNotEmpty(form.name) ? "Required" : "",
            username: !validation.isNotEmpty(form.username) ? "Required" : "",
            role: !form.role || !validation.isNotEmpty(form.role) ? "Required" : "",
            confirmPassword: form.password ? (form.password === confirmPassword) ? null : " must be same as Password" : ""
        }))
    }, [form, confirmPassword])

    const onChange = (e) => {
        if (e.phoneNumber && e.phoneNumber.length > 14) {
            setForm(prev => ({
                ...prev,
            }))
        } else if (e.name && e.name.length >= 21) {
            setForm(prev => ({
                ...prev,
            }))
        } else if (e.limitedAccess && e.limitedAccess.length >= 21) {
            setForm(prev => ({
                ...prev,
            }))
        } else {
            setForm(prev => ({
                ...prev,
                ...e
            }))
        }
    }

    const getAdminDetail = async (id) => {
        console.log('log-params ++', id)
        try {
            let { data, error } = await getAdmin(id)
            if (error) throw error
            if (data) {
                if (!partnerId && data.merchantId) { window.location.replace(`/${getUrlCourtCode()}/admins`) }
                let currRole = roleOption.find(value => value.value === data.role)
                setForm({ ...data, merchantId: partnerId, role: currRole, password: '' })
            }
        } catch (error) {
            console.log(error)
        }
    }


    const updateOrCreate = () => {
        if (form._id) {
            update()
        } else {
            create()
        }
    }

    const create = async () => {
        try {
            if (!(form.password && confirmPassword)) {
                console.log('required password')
                return
            } else if (listAdmin.find(v => v.username == form.username)) {
                setJOI(({ username: "Username already taken" }));
                return
            }
            let body = { ...form, username: `${partnerCode ? `${partnerCode}-` : ''}${form.username}` }
            if (body.role) {
                body.role = body.role.value
            }
            let { data, error } = await createAdmin(body)
            if (error) throw error
            if (data) {
                setForm(data)
                // Confirm("", "Admin created")
                toastMessage('Admin created', {
                    toastId: "admin-success",
                    type: "success"
                });
                if (partnerId) {
                    window.location.replace(`/${getUrlCourtCode()}/merchants/admins/edit/${data._id}?partnerId=${partnerId}&partnerCode=${partnerCode}&merchantId=${placeId}`)
                } else {
                    window.location.replace(`/${getUrlCourtCode()}/admins/edit/${data._id}`)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const update = async () => {
        try {
            let body = { ...form }
            console.log('here body', body)
            if (body.role) {
                body.role = body.role.value
            }
            if (body.password || !body.isActive) {
                body.deleteToken = true
            }
            let { data, error } = await updateAdmin(body)
            if (error) throw error
            if (data) {
                // setForm(data)
                console.log('success')
                if (partnerId) {
                    window.location.replace(`/${getUrlCourtCode()}/merchants/admins/edit/${body._id}?partnerId=${partnerId}&partnerCode=${partnerCode}&merchantId=${placeId}`)
                } else {
                    window.location.replace(`/${getUrlCourtCode()}/admins/edit/${body._id}`)
                }
            }
        } catch (error) {
            console.log('here error', error)
        }
    }

    return (
        <>
            <Grid item container xs={12} md={12} lg={12}>
                <Grid xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <Card sx={{ mb: 3 }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 3
                        }}>
                            <Grid container sx={{ p: 2 }}>
                                {/* <Grid xs={12} md={12} sx={{ p: 1 }}>
                                    <TCTitleLabel>{form._id ? 'Update Admin' : 'Add Admin'}</TCTitleLabel>
                                </Grid> */}
                                <Grid item container xs={12} md={12}>
                                    <Grid container xs={10} md={10} sx={{ p: 1, display: 'flex', gap: 2 }}>
                                        {
                                            (partnerCode && !form._id) &&
                                            <Grid item>
                                                <TCInput label={"Merchant ID"} disabled={true} value={`${partnerCode}-`} />
                                            </Grid>
                                        }
                                        <Grid item xs>
                                            <TCInput disabled={form._id ? true : false}
                                                showAlert={joi.username}
                                                label={"Username*"} onChange={(e) => onChange({ username: e.currentTarget.value.trim() })} value={form.username} />
                                        </Grid>
                                    </Grid>
                                    <Grid xs={2} md={2} sx={{ p: 1 }} >
                                        <TCLabel style={{ marginLeft: 10 }}>Status</TCLabel>
                                        <Switch checked={form.isActive} onChange={() => onChange({ isActive: !form.isActive })} />
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Name*"} showAlert={joi.name} onChange={(e) => onChange({ name: e.currentTarget.value.trimStart() })} value={form.name} />
                                </Grid>
                                <Grid xs={12} md={12} sx={{ p: 1 }}>
                                    <TCSelect label={"Role*"} options={partnerCode ? [{ value: 'superadmin', label: "Super Admin" }] : roleOption} showAlert={joi.role} value={form.role} onChange={(e) => {
                                        onChange({ role: e })
                                    }} />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Phone Number"} value={form.phoneNumber} onChange={(e) => onChange({ phoneNumber: e.currentTarget.value.replace(/[^0-9]+/ig, '') })} />
                                </Grid>
                                <Grid xs={12} md={12} sx={{ p: 1 }}>
                                    <TCLabel>Limited Access</TCLabel>
                                    <Grid container spacing={1}>
                                        <Grid item mt={0.8}>
                                            {
                                                form.limitedAccess ? <IconLock color={"#f44336"} /> : <IconLockOpen color={"#69f0ae"} />
                                            }
                                        </Grid>
                                        <Grid item xs>
                                            <TCInput label={""} value={form.limitedAccess} onChange={(e) => onChange({ limitedAccess: e.currentTarget.value.trim() })} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Password"} type={"password"} value={form.password} onChange={(e) => onChange({ password: e.currentTarget.value })} />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput label={"Confirm Password"} showAlert={joi.confirmPassword} type={"password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.currentTarget.value)} />
                                </Grid>
                            </Grid>
                            <Grid container direction={"row"} sx={{
                                pl: 3
                            }}>
                                <Button
                                    variant="contained"
                                    onClick={() => { updateOrCreate() }}
                                    disabled={
                                        (joi.name || joi.username || joi.role) ? true :
                                            form._id ? form.password === confirmPassword ? false : true : form.password && confirmPassword && form.password === confirmPassword ? false : true
                                    }
                                >
                                    {form._id ? "Update" : "Create"}
                                </Button>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}
